module.exports = __webpack_public_path__ + "img/edit-mobile.cd194fb.svg";